// extracted by mini-css-extract-plugin
module.exports = {"container":"legals_container__WvCZi","column":"legals_column__0Jt06"};